import {PlugIcon} from '@primer/octicons-react'
import {useState} from 'react'

import styles from './ConnectorLogo.module.css'

export interface ConnectorLogoProps {
  /** Logo URL from the catalog. Falls back to a generic icon when absent or broken. */
  src?: string
  /** Display name, used to describe the fallback icon. */
  name: string
  size?: number
}

export function ConnectorLogo({src, name, size = 32}: ConnectorLogoProps) {
  // Track which URL failed so a new src is retried instead of staying broken.
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const showFallback = !src?.trim() || failedSrc === src

  return (
    <span className={styles.logo} style={{width: size, height: size}} data-testid="connector-logo">
      {showFallback ? (
        <PlugIcon size={Math.round(size * 0.55)} aria-label={`${name} logo placeholder`} />
      ) : (
        <img className={styles.image} src={src} alt="" onError={() => setFailedSrc(src ?? null)} />
      )}
    </span>
  )
}
